import { render } from "./Controls.vue?vue&type=template&id=d92150d8&scoped=true&ts=true"
import script from "./Controls.vue?vue&type=script&lang=ts"
export * from "./Controls.vue?vue&type=script&lang=ts"

import "./Controls.vue?vue&type=style&index=0&id=d92150d8&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d92150d8"]])

export default __exports__